import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { topManagerApi } from '../top-manager.api';

export const useTopManagerPeriods = () => {
  const { data, isLoading, error } = topManagerApi.useGetTopManagerPeriodsQuery();
  return {
    topManagerPeriods: data,
    error: extractNestJsErrorMessage(error),
    isLoading
  };
};
